/**
 * CORE
 * Entry point. Imports all JS modules in order:
 *
 * 1. Web components     — custom elements (register immediately)
 * 2. Base behaviors     — initialized on DOMContentLoaded
 *
 * Web components are imported at the top level because
 * customElements.define() needs to run before the DOM
 * parser encounters the elements. Base behaviors wait
 * for DOMContentLoaded since they query existing DOM.
 */

// ============================================================
// WEB COMPONENTS (Tier 2 & 3)
// Self-registering — import order doesn't matter
// ============================================================

import './components/_defer-image';
import './components/_c-spacer';
import './components/_c-video';
import './components/_c-numberlist';
import './components/_c-timeline';


// ============================================================
// BASE BEHAVIORS (Tier 1)
// Each module exports an init() function that checks
// for its own DOM elements before doing anything.
// ============================================================

import * as scroll from './base/_scroll';
import * as navigation from './base/_navigation';
import * as modal from './base/_modal';
import * as slideshow from './base/_slideshow';

document.addEventListener('DOMContentLoaded', () => {
  scroll.init();
  navigation.init();
  modal.init();
  slideshow.init();
});
